import React from 'react';
import PropTypes from 'prop-types';

import SrPercentTickerField from 'client/components/SrPercentTickerField/SrPercentTickerField';

const SrCommissionField = ({ formikBag }) => {
  const _onIncrease = () => {
    formikBag.setFieldValue(
      'commissionPercentClientPays',
      formikBag.values.commissionPercentClientPays + 0.01
    );
  };

  const _onDecrease = () => {
    formikBag.setFieldValue(
      'commissionPercentClientPays',
      formikBag.values.commissionPercentClientPays - 0.01
    );
  };

  return (
    <SrPercentTickerField
      value={formikBag.values.commissionPercentClientPays}
      onDecrease={_onDecrease}
      onIncrease={_onIncrease}
    />
  );
};

SrCommissionField.propTypes = {
  formikBag: PropTypes.object.isRequired,
};

SrCommissionField.displayName = 'SrCommissionField';

export default SrCommissionField;
